import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceStdPage {
    lookupService = new APIServiceLookUp();

    async getAllStdPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}stdPage/getAllStdPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getStdPageById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}stdPage/getStdPageById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateStdPagePage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}stdPage/updateStdPagePage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setStdPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}stdPage/setStdPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delStdPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}stdPage/delStdPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}